<template>
  <div class="question-select">
    <div class="option-list">
      <el-input v-model="filterName" clearable class="filter" :placeholder="$t('company.placeholder.filter')"></el-input>
      <div
        v-for="(item, index) in filteredOptionList"
        class="option-item"
        :key="index"
        :class="checkedIds[item.id] && 'checked'"
        @click="onOptionItemClick(item)">
        <span class="check-icon iconfont icontick-01"></span>
        <div class="item-name">{{ getItemDisplayName(item) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getI18nPropertyValue } from '@/i18n'
import _ from 'lodash'

export default {
  model: {
    prop: 'checked',
    event: 'onCheckedChange'
  },
  props: {
    checked: {
      type: [Number, String]
    },
    optionList: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    hasCityOptions: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      checkedCount: 0,
      checkedIds: {},
      checkedDisplayName: '',
      filterName: ''
    }
  },
  computed: {
    isEnglish () {
      return this.$i18n.locale === 'en'
    },
    checkedWatcher () {
      return this.checked
    },
    filteredOptionList () {
      const optionList = _.cloneDeep(this.optionList)
      let orderList = optionList.sort((a, b) => this.getItemDisplayName(a).localeCompare(this.getItemDisplayName(b)))
      if (this.hasCityOptions) {
        orderList = _.orderBy(
          orderList,
          [
            option => {
              if (option.cn_name === '其它') {
                return 1
              } else if (option.cn_name === '海外') {
                return 2
              } else if (option.cn_name === '远程办公') {
                return 3
              } else {
                return 4
              }
            }
          ],
          ['desc']
        )
      }
      return _.filter(orderList, option => _.toUpper(this.getItemDisplayName(option)).includes(_.toUpper(this.filterName)))
    }
  },
  created () {
    this.refreshCheckedIds()
  },
  methods: {
    refreshCheckedIds () {
      if (this.checked) {
        const checkedIds = {}
        if (typeof this.checked === 'string') {
          const checkedIdArr = this.checked.split(',')
          _.forEach(checkedIdArr, item => {
            const index = _.findIndex(this.optionList, (optionItem) => {
              const optionId = optionItem.id + ''
              return optionId === item
            })
            if (index > -1) {
              checkedIds[item] = true
            }
          })
        } else {
          const index = _.findIndex(this.optionList, (optionItem) => {
            const optionId = optionItem.id + ''
            return optionId === this.checked
          })
          if (index > -1) {
            checkedIds[this.checked] = true
          }
        }
        const realChecked = Object.keys(checkedIds).join(',')
        if (realChecked.length !== (this.checked + '').length) {
          this.$emit('onCheckedChange', realChecked)
        }
        this.checkedIds = checkedIds
      }
    },
    onOptionItemClick (item) {
      const isChecked = this.checkedIds[item.id]
      if (isChecked) {
        this.checkedCount--
        this.$set(this.checkedIds, item.id, false)
      } else {
        if (this.multiple) {
          this.checkedCount++
          this.$set(this.checkedIds, item.id, true)
        } else {
          this.checkedIds = {
            [item.id]: true
          }
          this.checkedCount = 1
        }
      }
      const checkedIdArr = []
      const checkedDisplayNameArr = []
      _.forEach(this.checkedIds, (value, key) => {
        if (value) {
          checkedIdArr.push(key)
          const optionId = isNaN(key) ? key : parseInt(key)
          const optionItem = _.find(this.optionList, { id: optionId })
          checkedDisplayNameArr.push(this.getItemDisplayName(optionItem))
        }
      })
      this.$emit('onCheckedChange', checkedIdArr.join(','))
      this.checkedDisplayName = checkedDisplayNameArr.join(',')
    },
    getItemDisplayName (item) {
      const parent = this.$parent.$parent.$parent
      let name = ''
      if (parent.hasFilterOptions) {
        name = getI18nPropertyValue(item, 'cn_name', 'name')
      } else if (parent.hasCityOptions) {
        name = getI18nPropertyValue(item, 'cn_name', 'name')
      } else if (parent.hasCustomOptions) {
        name = getI18nPropertyValue(item, 'cn_value', 'en_value')
      } else if (parent.hasJobTypeOptions) {
        name = getI18nPropertyValue(item, 'cn_name', 'en_name')
      } else if (parent.hasRoleTypeOptions) {
        name = getI18nPropertyValue(item, 'cn_name', 'en_name')
      }
      return name
    }
  },
  watch: {
    checkedWatcher (newVal) {
      this.refreshCheckedIds()
    }
  }
}
</script>

<style lang="scss" scoped>
.question-select {
  .option-list {
    .option-item {
      line-height: 50px;
      cursor: pointer;
      position: relative;
      padding-left: 30px;

      &.checked {
        .check-icon {
          &::before {
            display: block;
          }
        }
      }

      .check-icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        border: 1px solid #e6e6e6;
        font-size: 18px;
        line-height: normal;
        position: absolute;
        top: 17px;
        left: 0;

        &::before {
          display: none;
          margin-top: -3px;
          margin-left: -2px;
        }
      }
    }

    .filter {
      position: sticky;
      top: 0;
      z-index: 1;

      ::v-deep {
        .el-input__inner {
          height: 50px;
          border-top: 0;
          border-left: 0;
          border-right: 0;
          border-radius: 0;
          padding: 0;
          border-color: #c7c7c7;
        }

        .el-input__icon {
          line-height: 50px;
        }
      }
    }
  }
}

.is-mobile {
  .question-select {
    .option-list {
      .option-item {
        &:not(:last-child) {
          border-bottom: 1px solid #e6e6e6;
        }
      }

      .filter {
        ::v-deep {
          .el-input__inner {
            border-color: #e6e6e6;
          }
        }
      }
    }
  }
}
</style>
